import React from "react";

interface IProps {
    size?: number;
    color?: string;
    className?: string;
};

const Minus = ({className, size=24, color="#000000"}: IProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
);

export default Minus;
